import React, { Component } from "react";
import { alert, loading, t } from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";

import HomeNavbar from "./components/HomeNavbar.js";
import HomeFooter from "./components/HomeFooter.js";
import HomeMedia from "./components/HomeMedia.js";

import ICON from "./icons.js";
import { loadArticles } from "./api.js";
import { openFreePost } from "./options.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import "../../assets/css/homepage.css";

/* ============================================================================
 * ArticleList — บทความอสังหาฯ ทั้งหมด (/articles)
 *
 * หน้าแรกโชว์บทความแค่แถวเดียว กด "ดูทั้งหมด" แล้วเปิดแท็บใหม่มาที่หน้านี้
 * เนื้อหาชุดเดียวกับหน้าแรก (ตั้งค่าที่ /ad/home/articles) แต่แสดงครบทุกรายการ
 * พร้อมคำโปรยและวันที่ ซึ่งการ์ดในหน้าแรกไม่มีที่พอจะแสดง
 *
 * ยังไม่มีหน้ารายละเอียดบทความในระบบ กดที่การ์ดจึงแจ้ง "กำลังพัฒนา" เหมือนเดิม
 * ========================================================================== */
class ArticleList extends Component {
  state = { section: { title: "" }, items: [], ready: false };

  componentDidMount() {
    document.title = `${t("home_articles_title")} | SafeSpace Life Living`;
    window.scrollTo({ top: 0 });
    this.Get();
  }

  Get = async () => {
    loading(true);
    const data = await loadArticles();
    loading(false);
    this.setState({ ...data, ready: true });
  };

  soon = (name) => alert("", "info", t("coming_soon_title"), `${name} — ${t("coming_soon_desc")}`, t("confirm"));

  open = (item) => alert("", "info", t("coming_soon_title"), `${item.title} — ${t("coming_soon_desc")}`, t("confirm"));

  render() {
    const { section, items, ready } = this.state;

    return (
      <div className="mn-home">
        <HomeNavbar onPost={openFreePost} />

        <section className="hm-pl">
          <div className="hm-container">
            <div className="hm-pl__head">
              <h1 className="hm-pl__title">{section?.title || t("home_articles_title")}</h1>
              <span className="hm-pl__count">{ready ? t("home_result_count").replace("{n}", items.length.toLocaleString()) : ""}</span>
            </div>

            {items.length ? (
              <div className="hm-grid hm-grid--list">
                {items.map((item) => (
                  <article key={item.uid} className="hm-article" onClick={() => this.open(item)}>
                    <div className="hm-article__media">
                      <HomeMedia src={item.src} kind={item.kind} tone={item.tone} ratio={1.15} alt={item.title} />
                      {!!item.tag && <span className="hm-badge hm-badge--light hm-article__tag">{item.tag}</span>}
                    </div>
                    <div className="hm-article__body">
                      <h3 className="hm-article__title">{item.title}</h3>
                      {!!item.desc && <p className="hm-article__desc">{item.desc}</p>}
                      <span className="hm-article__more">
                        {t("home_article_more")}
                        <span className="hm-ico">{ICON.arrow_right}</span>
                      </span>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              ready && <div className="text-center py-5 hm-muted">{t("home_empty")}</div>
            )}
          </div>
        </section>

        <HomeFooter data={{}} socials={[]} onLink={(key) => this.soon(t(key))} onSubscribe={() => this.soon(t("home_footer_subscribe"))} />
      </div>
    );
  }
}

export default withRouter(ArticleList);
